/**
 * @format
 */

import { useContext, useEffect, useState } from 'react';

import { Link, useLocation } from 'react-router-dom';

import { EventContext } from '../../../Contexts/EventContext';
import Loading from '../../../Shared/Components/Loading';
import ModalCustom from '../../../Shared/Components/ModalCustom';
import Pagination from '../../../Shared/Components/Pagination';
import SwitchButton from '../../../Shared/Components/SwitchButton';
import { error, success } from '../../../Shared/Components/Toast';
import useApi from '../../../Shared/hooks/api/Index';
import { useAccess } from '../../../Shared/hooks/useAccess';
import Master from '../../Layouts/Master';

const MatchStyle = () => {
  const eventContext = useContext(EventContext);
  const { search } = useLocation();
  const [loading, setLoading] = useState(false);
  const [removeLoading, setRemoveLoading] = useState(false);
  const [matchStyleRemoveId, setMatchStyleRemoveId] = useState();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { canManageBaseData } = useAccess();

  useEffect(() => {
    getMatchStyle();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);
  const getMatchStyle = async () => {
    setLoading(true);
    await useApi.get(
      `/panel/base/match-style/${search}`,
      {},
      (res) => {
        eventContext.matchStyles = res.data;
        setLoading(false);
      },
      (err) => {
        setLoading(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
      },
    );
  };
  const removeMatchStyle = async (matchStyleId) => {
    setRemoveLoading(true);

    await useApi.delete(
      `/panel/base/match-style/${matchStyleId}`,
      {},
      (res) => {
        success('سبک مسابقات مورد نظر با موفقیت حذف شد');
        setRemoveLoading(false);
        setModalIsOpen(false);
        getMatchStyle();
      },
      (err) => {
        setRemoveLoading(false);
        setLoading(false);
        error('حذف به علت خطا انجام نشد');
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <Master>
      <div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
        <div className='d-flex flex-row mt-2'>
          <i className='fad fa-list f-20 text-secondary mx-2'></i>
          <h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
            لیست سبک مسابقات
          </h1>
        </div>
        {canManageBaseData() && (
          <Link
            to='/panel/base-define/match-style/create'
            className='d-flex flex-row btn btn-outline-info '
          >
            <i className='fad fa-plus f-16 mx-2'></i>
            <span className='f-13'>ایجاد سبک مسابقات</span>
          </Link>
        )}
      </div>
      <div className='w-100 overflow-auto'>
        {eventContext.matchStyles?.data?.length > 0 ? (
          <table className='table table-hover'>
            <thead>
              <tr>
                <th>#</th>
                <th>عنوان</th>
                <th>دسترسی</th>
                <th>نوع</th>
                <th>ثبت نام توسط</th>
                <th>سطح برگزاری</th>
                <th>تایید توسط</th>
                <th>تعداد افراد مجاز</th>
                <th>تعداد تیم مجاز</th>
                <th>رایگان</th>
                <th>انتخاب استان های مجاز</th>
                <th>وضعیت</th>
                {canManageBaseData() && <th>عملیات</th>}
              </tr>
            </thead>
            <tbody>
              {eventContext.matchStyles?.data?.map((item) => (
                <tr key={item.id}>
                  <th>{item.id}</th>
                  <td>{item.title}</td>
                  <td>
                    {item?.access_by?.map((access) => (
                      <>{access?.description} /</>
                    ))}
                  </td>
                  <td>
                    {item?.match_kind?.map((matchKind) => (
                      <>{matchKind?.name} /</>
                    ))}
                  </td>
                  <td>{item?.register_by?.description}</td>
                  <td>{item?.competition_level?.name}</td>
                  <td>{item?.accept_by?.description ?? 'تعریف کننده'}</td>
                  <td>{item?.allowed_person}</td>
                  <td>{item?.allowed_team}</td>
                  <td>
                    <SwitchButton checked={item.is_free === 1 ? true : false} />
                  </td>
                  <td>
                    <SwitchButton checked={item.is_free === 1 ? true : false} />
                  </td>
                  <td>
                    <span
                      className={`badge badge-${
                        item.status === 0 ? 'danger' : 'success'
                      } badge-pill p-2`}
                    >
                      {item.status === 0 ? 'غیرفعال' : 'فعال'}
                    </span>
                  </td>
                  {canManageBaseData() && (
                    <td>
                      <div className='d-flex flex-row'>
                        <Link
                          to={`/panel/base-define/match-style/edit/${item.id}`}
                          className='mx-2'
                        >
                          ویرایش
                        </Link>
                        {canManageBaseData() && (
                          <Link
                            to='#'
                            className='mx-2'
                            onClick={(e) => {
                              e.preventDefault();
                              setMatchStyleRemoveId(item.id);
                              setModalIsOpen(true);
                            }}
                          >
                            حذف
                          </Link>
                        )}
                      </div>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className='d-flex flex-row justify-content-center border p-3 my-3	'>
            <i className='fad fa-plus f-16 mx-2 text-secondary'></i>
            <span className='f-13 font-weight-bold text-secondary'>
              برای ایجاد سبک مسابقات بر روی منوی ایجاد سبک مسابقات کلیک کنید
            </span>
          </div>
        )}
      </div>
      <div className='w-100 mt-4 d-flex'>
        <Pagination
          totalPage={eventContext.matchStyles?.meta?.pagination?.total_pages}
          basePath='/panel/base-define/match-style'
        />
      </div>
      <ModalCustom modalIsOpen={modalIsOpen}>
        <div className='d-flex flex-row border-bottom pb-2'>
          <i className='fad fa-warning f-20 mx-2'></i>
          <span className=''>آیا از حذف سبک مسابقات مطمئنید‌؟</span>
        </div>
        <div className='d-flex flex-row justify-content-around my-3'>
          <button
            onClick={() => setModalIsOpen(false)}
            className='btn btn-danger w-48 f-13'
          >
            لغو
          </button>
          <button
            onClick={() => removeMatchStyle(matchStyleRemoveId)}
            className='btn btn-success w-48 f-13'
          >
            {removeLoading ? (
              <div
                className='spinner-border spinner-border-sm text-white mb-1'
                role='status'
              ></div>
            ) : (
              'بله'
            )}
          </button>
        </div>
      </ModalCustom>
    </Master>
  );
};

export default MatchStyle;
